export class RegisterHitPlaneConfig {
}
RegisterHitPlaneConfig.point_color = 0xFF0000;
//# sourceMappingURL=RegisterHitPlaneConfig.js.map